<template>
  <footer class="vs-footer">
    <div class="content has-text-centered">
      <BDropdown position="is-top-left">
        <button slot="trigger" class="button">
          <span><Language /></span>
          <span class="text">{{ "language" | t }}</span>
          <i class="icon-angle-down" aria-hidden="true" />
        </button>
        <BDropdownItem v-for="locale in locales" :key="locale.code" @click="setCurrentLocale(locale.code)">
          {{ locale.name }}
        </BDropdownItem>
      </BDropdown>
      <p>
        <a class="link" href="mailto:japan@virtusize.com">
          {{ "contactUs" | t }}
        </a>
      </p>
      <p>© 2019 Virtusize</p>
    </div>
  </footer>
</template>

<script>
import Language from "@/assets/logos/language.svg";
import LOCALES from "@/misc/locales";

export default {
  name: "Footer",
  components: {
    Language,
  },
  data() {
    return {
      locales: LOCALES,
    };
  },
  methods: {
    setCurrentLocale(code) {
      localStorage.setItem("vsAnalyticsLocale", code);
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.vs-footer {
  padding: 30px 0;
  color: $gray-700;
  font-size: 13px;
  background-color: inherit;

  .dropdown {
    margin-bottom: 1em;
  }

  .text {
    padding: 0 10px;
  }

  .link {
    text-decoration: none;
  }
}
</style>
